<!--
 * @Author: chengchangjun
 * @Description: 宣传月度目标
-->
<template>
  <el-card :body-style="{ height: '100%', overflow: 'auto' }" class=" h-full">
    <div class="flex mb-20px">
      <el-date-picker
        size="small mr-10px"
        v-model="monthTime"
        type="month"
        :placeholder="$t('请选择日期')"
        value-format="yyyy-MM"
        clearable
      >
      </el-date-picker>
      <el-button size="small" type="primary" @click="getTableData">
        {{ $t('搜索') }}
      </el-button>
      <el-button size="small" type="primary" @click="reset">
        {{ $t('重置') }}
      </el-button>
      <el-button size="small" type="primary" @click="operateBtn('', 'create')">
        {{ $t('新增') }}
      </el-button>
    </div>
    <div class="h-[calc(100%-104px)]">
      <el-table :data="tableData" v-loading="tableLoading" ref="table" border height="100%">
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column prop="time" :label="$t('计划月度')" />
        <el-table-column prop="creator" :label="$t('创建人')" />
        <el-table-column prop="creationTime" :label="$t('创建时间')" />
        <el-table-column :label="$t('操作')" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="operateBtn(scope.row, 'read')">
              {{ $t('查看') }}
            </el-button>
            <el-button size="mini" @click="operateBtn(scope.row, 'update')">
              {{ $t('编辑') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      class="mt-20px text-right"
      background
      @current-change="getTableData"
      @size-change="getTableData"
      :current-page.sync="page.pageNo"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :page-size.sync="page.pageSize"
      :total="page.total"
      :pager-count="5"
    ></el-pagination>
  </el-card>
</template>

<script>
// tool
import { get, map, isNil, isEmpty } from 'lodash'
import dayjs from 'dayjs'
// api
import { RoyaltiesTargetApi } from '@wiz-api/workbench'

const royaltiesTargetApi = new RoyaltiesTargetApi()

export default {
  data() {
    return {
      tableData: [],
      tableLoading: true,
      monthTime: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    operateBtn(row, type) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/promote-monthly-goals-detail`,
        query: {
          type,
          time: get(row, 'time') || null,
        },
      })
    },
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await royaltiesTargetApi.page({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          time:
            isNil(this.monthTime) || isEmpty(this.monthTime)
              ? null
              : dayjs(this.monthTime).format('YYYY-MM-01 00:00:00'),
        },
      })
      if (!err) {
        this.tableData = map(res.items, (item) => {
          return {
            ...item,
            time: dayjs(item.time).format('YYYY-MM'),
            creationTime: dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss'),
          }
        })
        this.page.total = res.totalCount
        this.tableLoading = false
      }
    },
    async reset() {
      this.monthTime = ''
      await this.getTableData()
    },
  },
  created() {
    this.getTableData()
  },
}
</script>
